import { Box, Grid, Link, Typography, useTheme } from "@mui/material";
import { Command } from "~/components/guides/components/command";
import { Markdown } from "~/components/markdown";
import { useToken } from "~/providers/token";
import { getCiscoInstallCommand } from "./utils";
import { IntegrationAddHeader } from "../headers/IntegrationAddHeader";
import { OtherIntegrations } from "../headers/types";
import { CISCO_SCAN_COMMAND } from "~/pages/integrations/cisco/constants";
import { formatTokenExpiration } from "../os/linux/utils";

export const CiscoIntegrationSetupPage = () => {
  const theme = useTheme();
  const { token, refreshToken, tokenTimeLeft } = useToken();
  const ciscoInstallCommand = getCiscoInstallCommand(token?.value ?? "");

  return (
    <>
      <IntegrationAddHeader type={OtherIntegrations.CISCO} />
      <Box sx={{ mt: 3 }}>
        <Box sx={{ mb: 2 }}>
          <Command
            number={1}
            options={{
              fontSize: { xs: 16 },
              dotColor: theme.palette.background.lightest,
            }}
          >
            Install cnspec on your Linux or macOS scanning workstation
          </Command>
        </Box>
        <Box sx={{ pl: 6, mb: 5 }}>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
            Install cnspec by running these commands as root
          </Typography>
          <Markdown source={`\`\`\`bash\n${ciscoInstallCommand}\n\`\`\``} />
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ ml: 2, mt: -1, display: "block" }}
          >
            Your Mondoo Registration Token expires in{" "}
            {formatTokenExpiration(tokenTimeLeft)}.{" "}
            <Link
              component="button"
              onClick={refreshToken}
              sx={{
                color: "primary.light",
                verticalAlign: "inherit",
                textDecoration: "none",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              Refresh token
            </Link>
            .
          </Typography>
        </Box>

        <Box sx={{ mb: 2 }}>
          <Command
            number={2}
            options={{
              fontSize: { xs: 16 },
              dotColor: theme.palette.background.lightest,
            }}
          >
            Use cnspec to scan your Cisco device
          </Command>
        </Box>
        <Box sx={{ pl: 6 }}>
          <Grid>
            <Markdown source={`\`\`\`bash\n${CISCO_SCAN_COMMAND}\n\`\`\``} />
          </Grid>
        </Box>
      </Box>
    </>
  );
};
